module.exports = __webpack_public_path__ + "media/rob.27c6fb94.wav";